import { getTelegramWebApp, isTMA } from '@web/libs/tg/platform'
import { safeTelegramCall } from '@web/libs/tg/safe-call'

export function installTmaSwipeBehavior(): void {
  if (!isTMA()) return

  // Жесты шитов и списков не должны сворачивать мини-приложение.
  safeTelegramCall(() => getTelegramWebApp()?.disableVerticalSwipes?.())
}
